(function () {
  'use strict';
  var IQ = (window.IQ = window.IQ || {});
  var KEY = 'iq_cart_timer';
  var els = new Set();
  var ticker = null;
  var memory = null;
  var requestId = 0;
  var count = Number(IQ.cartCount) || 0;

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || 'null'); return v && Number.isFinite(Number(v.until)) ? (memory = v) : memory; } catch (e) { return memory; }
  }
  function write(v) { memory = v; try { if (v) localStorage.setItem(KEY, JSON.stringify(v)); else localStorage.removeItem(KEY); } catch (e) {} }
  function minutes() { var m = parseInt(IQ.reserveMinutes, 10); return m === 5 ? 5 : 10; }
  function enabled() { return IQ.timer != null ? !!IQ.timer : !!IQ.urgency; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(ms) { var t = Math.max(0, Math.ceil(ms / 1000)); return pad(Math.floor(t / 60)) + ':' + pad(t % 60); }

  function start(token) {
    var v = { until: Date.now() + minutes() * 60000, token: token || null };
    write(v);
    return v;
  }
  /* Ajusta el estado al carrito real (cart.js). Nunca reinicia un periodo que sigue vigente para el mismo carrito. */
  function sync(cart) {
    if (!cart) return;
    count = cart.item_count;
    var v = read();
    if (count === 0) { if (v) write(null); render(); return; }
    var token = String(cart.token || '').split('?')[0] || null;
    if (!v) v = start(token);
    else if (v.token && token && v.token !== token) v = start(token);
    else if (!v.token && token) { v.token = token; write(v); }
    render();
  }
  IQ.cartTimerSync = sync;

  function render() {
    var v = read();
    var on = !!(enabled() && v && count > 0);
    els.forEach(function (el) {
      el.hidden = !on;
      if (!on) return;
      var ms = v.until - Date.now();
      var time = el.querySelector('[data-time]');
      var text = el.querySelector('[data-text]');
      var done = el.querySelector('[data-done]');
      var expired = ms <= 0;
      el.classList.toggle('is-expired', expired);
      if (text) text.hidden = expired;
      if (done) done.hidden = !expired;
      if (time) {
        var s = fmt(ms);
        if (time.textContent !== s) time.textContent = s;
        var seconds = Math.max(0, Math.ceil(ms / 1000));
        time.setAttribute('datetime', 'PT' + seconds + 'S');
      }
    });
    if (on && read().until > Date.now()) { if (!ticker) ticker = setInterval(render, 1000); }
    else if (ticker) { clearInterval(ticker); ticker = null; }
  }

  if (window.customElements && !customElements.get('iq-reserve')) {
    customElements.define('iq-reserve', class extends HTMLElement {
      connectedCallback() { els.add(this); render(); queue(); }
      disconnectedCallback() { els.delete(this); queue(); }
      reset() { render(); } /* iq.js la llama al añadir artículos: aquí no reinicia el periodo */
    });
  }

  function fetchCart() {
    var id = ++requestId;
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); }).then(function (cart) { if (id === requestId) sync(cart); }).catch(function () {});
  }
  var queued = null;
  function queue() { clearTimeout(queued); queued = setTimeout(fetchCart, 250); }

  /* Estado inicial: el número de artículos viene del servidor (snippets/iq-config) */
  fetchCart();

  ['cart:update', 'cart:updated', 'cart:change', 'shopify:cart:discount-update'].forEach(function (ev) { document.addEventListener(ev, queue); });
  document.addEventListener('shopify:cart:lines-update', function (e) {
    var p = e.promise || (e.detail && e.detail.promise);
    if (p) Promise.resolve(p).then(fetchCart, function () {});
  });
  try {
    new PerformanceObserver(function (list) {
      if (list.getEntries().some(function (e) { return /\/cart\/(add|change|update|clear)/.test(e.name); })) queue();
    }).observe({ type: 'resource', buffered: false });
  } catch (e) {}
  /* Otra pestaña cambió el estado */
  window.addEventListener('storage', function (e) { if (e.key === KEY) { memory = null; fetchCart(); } });
  /* Al volver a la pestaña o desde la caché del navegador */
  window.addEventListener('pageshow', function () { fetchCart(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) render(); });
})();
